exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.my-container[data-v-71c6923e]{\n    height: calc(100vh);\n    width: calc(100% - 170px);\n    background-color: #F8F9FA;float: left;\n}\n", ""]);

